import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { getFieldValue } from '../utils/formUtils';
import { alpha } from '@mui/material/styles';
import { useTheme } from '@mui/styles';

export const Answer = ({ question, answer, index, onSelect }) => {
  const theme = useTheme();
  if (!answer) return null;
  const { question_label } = question;
  const val = getFieldValue(question, answer).valueString;

  return (
    <Paper
      elevation={0}
      sx={{
        'p': 2,
        'mb': 1,
        'position': 'relative',
        'cursor': 'pointer',
        'overflow': 'hidden',
        'backgroundColor': alpha('#fff', 0.6),
        'boxShadow': `${alpha(
          theme.palette.primary.main,
          0.2,
        )} 0px 0px 4px 0px`,
        '&:hover': {
          '& div': {
            opacity: 1,
          },
        },
      }}
      onClick={() => onSelect(index)}
    >
      <Box
        position="absolute"
        height="100%"
        width="100%"
        sx={{
          top: 0,
          left: 0,
          opacity: 0,
          transition: 'opacity 0.2s ease-in-out',
          background:
            'linear-gradient(to right, rgba(255, 255, 255, 0), rgb(255, 255, 255))',
        }}
      />
      <Typography
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        fontWeight={600}
      >
        {question_label}: {val}
      </Typography>
      <Typography
        component="div"
        color="primary.main"
        sx={{
          position: 'absolute',
          right: 16,
          top: '50%',
          transform: 'translateY(-50%)',
          opacity: 0,
          transition: 'opacity 0.2s ease-in-out',
        }}
        fontWeight={600}
      >
        CHANGE
      </Typography>
    </Paper>
  );
};

const AnswersPreview = ({ questions, onSelect }) => {
  const form = useSelector((s) => s.form);
  return (
    <Box mb={2}>
      {questions.map((q, idx) => (
        <Answer
          question={q}
          answer={form[q.hash]}
          index={idx}
          key={q.id}
          onSelect={onSelect}
        />
      ))}
      <Answer />
    </Box>
  );
};

export default AnswersPreview;
